// Authentication utility functions

// Helper function to get cookie value
export const getCookie = (name) => {
  const cookieName = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return "";
};

// Helper function to decode JWT tokens
export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    console.error('Error parsing JWT token:', e);
    return null;
  }
};

// Get user email from JWT token
export const getUserEmail = () => {
  const idToken = getCookie('idToken');
  if (!idToken) {
    console.warn('No ID token found');
    return null;
  }
  
  const decoded = parseJwt(idToken);
  return decoded?.email || null;
};

// Get user name from JWT token
export const getUserName = () => {
  const idToken = getCookie('idToken');
  if (!idToken) return null;
  
  const decoded = parseJwt(idToken);
  return decoded?.name || decoded?.email || null;
};

// Get user groups from JWT token
export const getUserGroups = () => {
  const idToken = getCookie('idToken');
  if (!idToken) return [];
  
  const decoded = parseJwt(idToken);
  return decoded?.['cognito:groups'] || [];
};
